module.exports = __webpack_public_path__ + "static/media/sohoj.0ff366ac.svg";